export default "__VITE_ASSET__BqsJDr17__"